import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useRepairListModel } from "../repairListModel";
import { IVRMRepairListDetail } from "../repairListService";
import { formatNum } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";
import YhTootip from "@/components/YhTootip";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useRepairListModel();
    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        loadData();
    }, [])

    const columns: ColumnsType<IVRMRepairListDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            align: "center",
            render: (t, r, i) => i + 1
        }, {
            title: '单据编号',
            width: 200,
            dataIndex: 'code',
            // render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>
        }, {
            title: '客户名称',
            width: 200,
            dataIndex: 'customerName',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>
        }, {
            title: '单据类型',
            width: 150,
            dataIndex: 'tradeTypeName',
        }, {
            title: '维修类型',
            width: 150,
            dataIndex: 'serviceNatureName',
        }, {
            title: '结算类型',
            width: 150,
            dataIndex: 'payType',
            render: text => getTreeNodeName(text)
        }, {
            title: '单据状态',
            width: 150,
            dataIndex: 'status',
            render: text => getTreeNodeName(text)
        }, {
            title: '支付状态',
            width: 150,
            dataIndex: 'payStatus',
            render: text => getTreeNodeName(text)
        }, {
            title: '优惠后工时',
            width: 150,
            dataIndex: 'totalAmount',
            render: (text) => `￥${text}`
        }, {
            title: '优惠后配件',
            width: 150,
            dataIndex: 'discountTotalAmount',
            render: (text) => `￥${text}`
        }, {
            title: '营业额',
            width: 150,
            dataIndex: 'receivableTotalAmount',
            render: (text) => `￥${text}`
        }, {
            title: '销售成本',
            width: 150,
            dataIndex: 'totalCost',
            render: (text) => `￥${text}`
        }, {
            title: '销售毛利',
            width: 150,
            dataIndex: 'grossProfit',
            render: (text) => text ? '￥' + text : '￥0'
        }, {
            title: '制单员',
            width: 150,
            dataIndex: 'createUser',
        }, {
            title: '制单日期',
            width: 160,
            dataIndex: 'createTime',
        }, {
            title: '结算日期',
            width: 160,
            dataIndex: 'settleTime',
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        }
    ];

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            rowKey={record => record.id}
            // rowSelection={{
            //     selectedRowKeys: selectedRowKeys, //记录选中
            //     //全部选中时  (存string[])
            //     onSelectAll: (selected, selectedRows, changeRows) => {
            //         let changeRowId = changeRows.map(item => item.id);
            //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
            //             : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
            //     },
            //     onSelect: (record) => onRow(record.id),
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.id)
            // })}
            scroll={{ x: 'max-content', y: "calc(100vh - 340px)" }}
        />
    )
}